import { requireOptionalNativeModule } from 'expo';
import { Platform } from 'react-native';

/**
 * Whether this install can play a video inside the app. expo-video's native
 * half ships in app builds from 0.1.2 on, but older builds still get today's
 * JS by OTA, and importing expo-video there throws. So anything that imports
 * it must be loaded only after this says yes; older builds open the video in
 * the browser instead. Web always can.
 */
export function canPlayInline(): boolean {
  return Platform.OS === 'web' || requireOptionalNativeModule('ExpoVideo') != null;
}
